'use client'

import { useQuery } from '@tanstack/react-query'

import { fetchMaintenanceState } from '../lib/fetchMaintenanceState'

export const MAINTENANCE_STATE_QUERY_KEY = ['public-maintenance']

/**
 * Repete a leitura a cada minuto para que a tela de manutenção saiba sozinha
 * quando a janela terminou — sem isso, o aluno ficaria preso nela até recarregar.
 */
export function useMaintenanceState() {
  return useQuery({
    queryKey: MAINTENANCE_STATE_QUERY_KEY,
    queryFn: fetchMaintenanceState,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true
  })
}
